import queryString from "query-string";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { UserRoleEnum } from "../../static/enums/UserRole";
import { tableStore } from "../../mobx/stores/TableStore/TableStore";
import { PageQuery } from "../../api/users/UsersApi";
import { MergedFiltersQuerySerialized } from "../serializers/filters";

interface UseGetUsersOptions {
  with_trashed?: "0" | "1";
  role?: UserRoleEnum;
}

export function useGetUsers(options: UseGetUsersOptions = {}) {
  const location = useLocation();
  const history = useHistory();
  const { page, getUsers } = tableStore;
  const { to, from } = page;
  const params = (queryString.parse(location.search) as unknown) as PageQuery & {
    "filter[role]": UserRoleEnum;
  } & MergedFiltersQuerySerialized;
  const {
    "page[number]": currentPage,
    "page[size]": size,
    "filter[profiles][student][is_studying]": is_studying,
  } = params;
  if (options.role != null) params["filter[role]"] = options.role;
  if (options.role === UserRoleEnum.student && is_studying === undefined)
    params["filter[profiles][student][is_studying]"] = "1";

  useEffect(() => {
    if ((to == null || from == null) && currentPage !== "1" && currentPage !== undefined) {
      history.push({
        search: queryString.stringify({ ...params, "page[size]": "15", "page[number]": "1" }),
      });
    }
  }, [from, to]);

  useEffect(() => {
    getUsers({
      ...params,
      with_trashed: options.with_trashed || "0",
    });
  }, [currentPage, size]);
}
